import { Pipe, PipeTransform } from '@angular/core'
import { TranslatePipe as TransifexTranslatePipe } from '@emilfreydigital/transifex-angular'

@Pipe({
  name: 'translate',
  pure: false,
  standalone: false
})
export class HubTranslatePipe extends TransifexTranslatePipe implements PipeTransform {}
